import BaseComponent from '@tock/shared/components/BaseComponent';

class BannerParagraph extends BaseComponent {
  render() {
    return <p className="Banner-paragraph">{this.props.children}</p>;
  }
}

export default BannerParagraph;
